module.exports = __webpack_public_path__ + "static/img/1.801dc13.png";


//////////////////
// WEBPACK FOOTER
// ./src/district/assets/image/home/1.png
// module id = xt/o
// module chunks = 3